import { useQuery } from '@tanstack/react-query';
import { searchAllEntities } from '@/lib/api';

export function useGlobalSearch(query: string, enabled = true) {
  const search = query.trim();

  return useQuery({
    queryKey: ['global-search', search],
    queryFn: () => searchAllEntities(search),
    enabled: enabled && search.length >= 2,
    staleTime: 30_000,
  });
}
